/**
 * Service for managing mobile endpoints
 */export class MobileEndpointsService{constructor(api){this.api=void 0;this.api=api;}/**
   * Get all mobile endpoints for a tenant
   */async getTenantMobileEndpoints(tenantId){return this.api.get('/api/mobile-endpoints',{organizationId:tenantId});}/**
   * Get all mobile endpoints for an app
   */async getAppMobileEndpoints(appId){return this.api.get('/api/mobile-endpoints',{appId});}/**
   * Get a single mobile endpoint by ID
   */async getMobileEndpoint(id){return this.api.get(`/api/mobile-endpoints/${id}`);}/**
   * Create a new mobile endpoint
   */async createMobileEndpoint(data){return this.api.post('/api/mobile-endpoints',data);}/**
   * Update a mobile endpoint
   */async updateMobileEndpoint(data){const{id,...body}=data;return this.api.put(`/api/mobile-endpoints/${id}`,body);}/**
   * Delete a mobile endpoint
   */async deleteMobileEndpoint(id){await this.api.delete(`/api/mobile-endpoints/${id}`);}}